export default "assets/images/icons/weibo-1d4e5d09.svg";